import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
@Component({
  selector: "demo-config-codemirror",
  templateUrl: "./config-codemirror.component.html",
  styleUrls: ["./config-codemirror.component.scss"],
})
export class ConfigCodemirrorComponent implements OnInit {
  @Input() type: any = "";
  @Input() title = "";
  @Input() fieldData: any = {};
  @Input() options: any[] = [];
  @Input() ruleObj = "";
  showText: string = "";
  constructor() {}

  ngOnInit() {}
  textChange(str: string): void {
    this.showText = str;
  }
}
